import styles from '../../../styles/pages/index.module.scss';
import { getArticlesPage, getCmsPaths } from '../../api/Articles';
import { getCMSCategories } from '../../api/cms';
import CustomMetaHead from '../../components/CustomMetaHead';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import LayoutDynamicSingle from '../../components/LayoutDynamic/LayoutDynamicSingle';
import Navigation from '../../components/Navigation/Navigation';
import PageTitle from '../../components/Page Title/PageTitle';
import META_DATA from '../../constants/metaData';
import { getOrFetchFooterLinks } from '../../utils/footerLinks';
import { createBreadcrumbJson, getBreadcrumbTwoStep } from '../../utils/getBreadcrumb';
import { getOrFetchNavigationLinks } from '../../utils/navigationLinks';

export default function Contest({ contest, categories, navigation, footerLinks, appLinks, slug, meta }) {
  const breadcrumbData = getBreadcrumbTwoStep(slug);
  const breadcrumb = createBreadcrumbJson(breadcrumbData);

  if (!contest) {
    return null;
  }
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumb) }} />
      <CustomMetaHead meta={meta} />
      <div className={styles.headerContainer}>
        <Header navigation={navigation} />
        <Navigation navigation={navigation} />
      </div>
      <PageTitle title="Διαγωνισμοί" />
      <LayoutDynamicSingle data={contest} appLinks={appLinks} categories={categories} contentName="diagwnismoi" />
      <Footer footerLinks={footerLinks} />
    </>
  );
}

export async function getStaticPaths() {
  const contentType = 'diagwnismoi';
  const paths = await getCmsPaths(contentType);

  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  const contentType = 'diagwnismoi';
  const [{ data: contest }, { data: categories }, { data: navigation }, footerLinks] = await Promise.all([
    getArticlesPage(params, contentType),
    getCMSCategories('diagwnismoiCategory'),
    getOrFetchNavigationLinks(),
    getOrFetchFooterLinks(),
  ]);

  const { slug } = params;
  const appLinks = footerLinks?.appLinks?.data?.[0]?.fields || [];
  const meta = {
    ...META_DATA[process.env.appName].diagwnismoi,
    title: contest.data[0].title,
    description: contest.data[0].fields.summary,
    image: contest?.data[0]?.fields?.cover_image?.path || `/assets/${process.env.appName}/logo.png`,
    url: `${process.env.domain}/diagwnismoi/${slug}`,
  };

  return {
    props: {
      categories,
      contest,
      footerLinks,
      appLinks,
      navigation,
      slug: `diagwnismoi/${slug}`,
      meta,
    },
  };
}
